/**
 * @typedef  {{
 *   hiddenWhen?: ('OFFLINE' | 'ONLINE' | string)[];
 *   hiddenFor?: ('USER' | 'ADMIN' | 'SUPPORT' | string)[];
 *   showForViewPort?: ('MOBILE' | 'TABLET' | 'DESKTOP' | string)[];
 *   hideForViewport?: ('MOBILE' | 'TABLET' | 'DESKTOP' | string)[];
 *   removeForFeatureFlag?: string[];
 *   addForFeatureFlag?: string[];
 *   hiddenForValue?: { foreignNamespace?: string; foreignRelation?: string; propertyName: string; value: string }[];
 *   customizableVisibility?: { title: string; isTabAccess: boolean; accessTargetId: string; readonly: boolean }[];
 * }} AccessModifiers
 */

/**
 *
 * @param {string} title
 * @param {hNode[]} children
 * @param {AccessModifiers} methodAccess
 */
module.exports = function embedInSubMenu(title, children, methodAccess) {
    return {
        id: 'bb' + asciiToBase(title, 16, 22),
        title,
        hNodeType: 'NavHeading',
        hNodeTypeGroup: 'navHeading',
        ...methodAccess,
        children
    };
};

function asciiToBase(string, base = 16, length) {
    let result = [];
    for (let i = 0; i < string.length; i++) {
        const charCode = Number(string.charCodeAt(i)).toString(base);
        result.push(charCode);
    }
    if (length) {
        return result.join('').padEnd(length, '0').substring(0, length);
    }
    return result.join('');
}
